<script setup lang="ts">
interface Props {
  avatar?: string | null
  name: string
}

const props = withDefaults(defineProps<Props>(), { avatar: null })
</script>

<template>
  <div class="mx-auto max-w-sm space-y-4 border-t px-4 py-12">
    <twic-img
      v-if="props.avatar"
      :src="useTwicPicsBlogUrl(props.avatar)"
      class="mx-auto w-24 overflow-hidden rounded-full"
      focus="auto"
      :alt="name"
    />

    <div class="text-center">
      <p class="font-semibold">
        {{ props.name }}
      </p>
      <div class="text-center">
        <slot name="role" />
      </div>
    </div>

    <slot name="bio" />
  </div>
</template>
